import React from "react"
import _ from "lodash"
import { connect } from "react-redux"
import PropTypes from "prop-types"

import DefaultContainer from "shared/components/DefaultContainer"
import SpinnerLoad from "../SpinnerLoad"

import styles from "./styles.css"

import phoneFixedVoice from "../../../../assets/svg/phone-fixed-voice.svg"

const MyNumbers = ({
  loading,
  activeNumbers,
  inProgressNumbers,
  qntNumbers
}) => {
  const totalNumbers = _.toNumber(activeNumbers) + _.toNumber(inProgressNumbers)
  const numbersAcquired = qntNumbers > totalNumbers ? qntNumbers : totalNumbers
  const availableNumbers = numbersAcquired - activeNumbers
  const percentageActive = (activeNumbers / totalNumbers) * 100
  const percentageInProgress = (inProgressNumbers / totalNumbers) * 100
  const percentageAcquired = (totalNumbers / numbersAcquired) * 100
  const percentageUsed = isNaN(_.toNumber(percentageAcquired))
    ? 0
    : percentageAcquired !== Math.floor(percentageAcquired)
    ? _.toNumber(percentageAcquired).toFixed(2)
    : _.toNumber(percentageAcquired)

  if (loading) {
    return (
      <div className={styles.loading_numbers}>
        <SpinnerLoad />
      </div>
    )
  }

  return (
    <DefaultContainer customClass={styles.containerClass}>
      <div className={styles.my_numbers_container}>
        <div className={styles.title}>
          <div className={styles.primary_title}>Meus números</div>
          <div className={styles.badge}>{percentageUsed}% em uso</div>
        </div>

        <div className={styles.center}>
          <span className={styles.total_numbers}>
            {_.toNumber(numbersAcquired)}
          </span>
          <span className={styles.available_numbers}>
            {_.toNumber(availableNumbers - inProgressNumbers)} disponíveis para
            uso.
          </span>
          <img src={phoneFixedVoice} />
        </div>

        <div className={styles.graphics}>
          <div className={styles.full_space}>
            <div className={styles.text_container}>
              <div className={styles.text_left}>
                {_.toNumber(activeNumbers)} ativos
              </div>
              <div className={styles.text_right}>
                {_.toNumber(inProgressNumbers)} aguardando ativação
              </div>
            </div>

            <div className={styles.progressBarContainer}>
              <div className={styles.bar}>
                <div
                  className={styles.progress_bar_active}
                  style={{ width: `${percentageActive}%` }}
                ></div>
              </div>

              <div className={styles.bar}>
                {inProgressNumbers > 0 && (
                  <div
                    className={styles.progress_bar_progress}
                    style={{ width: `${percentageInProgress}%` }}
                  ></div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </DefaultContainer>
  )
}

MyNumbers.propTypes = {
  loading: PropTypes.bool,
  activeNumbers: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  inProgressNumbers: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  qntNumbers: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

const mapStateToProps = ({ customersFixedVoice }) => ({
  loading: customersFixedVoice.loading,
  activeNumbers: customersFixedVoice.activeNumbers,
  inProgressNumbers: customersFixedVoice.inProgressNumbers,
  qntNumbers: customersFixedVoice.qntNumbers
})

export default connect(mapStateToProps, null)(MyNumbers)



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/components/MyNumbers/index.js